import { isMessageKey } from '@/src/lang/isMessageKey'
import type { TMessageKey } from '@/src/lang/useTranslate'

import { Exception } from '../../errors/Exception'
import { HTTPException } from '../../errors/HTTPException'

export const parseApiError = (error: unknown, field?: string) => {
  if (error instanceof HTTPException) {
    const errorKey = field
      ? error.cause?.errors?.find((e) => ('property' in e ? e.property === field : e.propertyPath === field))?.message
      : error.cause?.errors?.[0]?.message
    if (errorKey && isMessageKey(errorKey)) {
      return errorKey
    }
  }

  if (error instanceof Exception && isMessageKey(error.message)) return error.message
  if (error instanceof Error && isMessageKey(error.message)) return error.message
  if (typeof error === 'string' && isMessageKey(error)) return error
}

export const parseApiErrors = <Field extends string>(error: unknown, fields: Field[]) => {
  const isField = (property: string): property is Field => (fields as string[]).includes(property)

  if (error instanceof HTTPException) {
    return error.cause?.errors?.reduce<[Field, TMessageKey][]>((acc, apiError) => {
      const property = 'property' in apiError ? apiError.property : apiError.propertyPath
      if (isField(property) && isMessageKey(apiError.message)) {
        acc.push([property, apiError.message])
      }
      return acc
    }, [])
  }
  return [] as [Field, TMessageKey][]
}
